import React, {Component} from 'react';
import {Route} from 'react-router-dom';
import axios from 'axios';
import {ListGroup, ListGroupItem, Col, Row, Progress, Card} from 'reactstrap';

//Components
import SideNavbar from './SideNavbarComponent';
import CourseProblemList from './CourseProblemListComponent';
import ProblemDetails from './ProblemDetailsComponent';
import CourseHomePageBreadcrumb from '../breadcrumbs/CourseHomePageBreadcrumb';
import CodeReview from './problemDetailsOptions/CodeReviewComponent';
import MarkdownRender from "../MarkdownRendererComponent";
import AllProblemsPage from '../AllProblemsPageComponent';

//Data
import {serverPath} from "../common";

//Style
import '../../css/coursedetails.css';
import '../../css/common.css';

// Route: /s/course/:courseId
class S_CourseHomePage extends Component{

    getData(user) {
        if(user === "") {user = this.state.user;}
        if(user === null) { return;}

        var self = this;
        axios.get(serverPath + "studentService.php", {
            params: {
                action: 'getCourseData',
                courseId: this.props.match.params.courseId,
                studentId: user.userId
            }
        }).then(function(response){
            self.setState({
                user: user,
                courseInfo: response.data.courseInfo,
                classes: response.data.classes,
                tests: response.data.tests,
                exams: response.data.exams,
                submissions: response.data.submissions
            });
        });
    }

    constructor(props) {
        super(props);

        this.state = {
            user: null,
            classes: [],
            tests: [],
            exams: [],
            courseInfo: {
                name: "",
                shortDescription: ""
            },
            submissions: null,
            codeReviewOpen: false,
            codeReviewSubmission:null
        };

        this.hideCodeReview = this.hideCodeReview.bind(this);
    }

    componentDidMount() {
        var self = this;
        axios.get(serverPath + "authService.php", {params: {action: 'whoIsLoggedIn'}})
            .then(function(response){
				if(response.data !== null && response.data.roleName === "student")
                {
                    self.getData(response.data);
                }
                else
                {
                    self.props.history.push("/home");
                }

            });
    }

    componentWillReceiveProps(newProps) {
        if(newProps.match.url !== this.props.match.url){
            this.props = newProps;
            this.getData("");
        }
    }

//Code review modal
    showCodeReview(submission) {
        if(submission.codeReview !== null) {
            if(submission.Seen === 0){//reading review for the first time
                var params = new FormData();
                params.append("action", "seenReview");
                params.append("id", submission.idProblemSubmission);
                axios.post(serverPath + "notificationService.php", params);//set seenReview to 1 in db
                submission.Seen = 1;
                this.props.removeNotification(submission.idProblemSubmission);
            }
            if(typeof submission.codeReview === "string") {
                submission.codeReview = JSON.parse(submission.codeReview);
            }

            this.setState({
                codeReviewSubmission: submission,
                codeReviewOpen: true
            });
        }
    }

    hideCodeReview() {
        this.setState({
            codeReviewOpen: false,
            codeReviewSubmission: null
        });
    }

    render() {

        var submissionsHtml = "";
        if(this.state.submissions !== null && this.state.submissions.length > 0) {
            submissionsHtml = this.state.submissions.map((s) => {
                var classes = 'fa fa-comments active';
                if(s.Seen === 0){
                    classes+=" notSeenReview";
                }
                return (
                    <ListGroupItem>
                        <Row>
                            <Col xs={3}> {s.timestamp} </Col>
                            <Col xs={5}> {s.problemName} </Col>
                            <Col xs={3}>
                                <Progress value={s.score}
                                          color={s.score === 100 ? 'success' : s.score === 0 ? 'danger' : 'warning'}> {s.score} </Progress>
                            </Col>
                            {
                                s.codeReview !== null ?
                                    <Col xs={1} title="Pogledaj komentar"
                                         className={classes}
                                         onClick={() => { this.showCodeReview(s)}}></Col>
                                    :
                                    <Col xs={1} title="Trenutno nema komentara" className={'fa fa-comments-o inactive'}></Col>
                            }
                        </Row>
                    </ListGroupItem>
                );
            });
            submissionsHtml = (
                <div className="card-container">
                    <Card>
                        <h3> Zahtevi za pregledanjem koda </h3>
                        <ListGroup>
                            {submissionsHtml}
                        </ListGroup>
                        <CodeReview showModal={this.state.codeReviewOpen} submission={this.state.codeReviewSubmission}
                                    closeModalHandler={this.hideCodeReview}/>
                    </Card>
                </div>
            );
        }

        return(
            this.state.user !== null ?
            <React.Fragment>
                <div className="row">
                    <SideNavbar classes={this.state.classes} exams = {this.state.exams} tests={this.state.tests} courseInfo = {this.state.courseInfo}/>
                    <div className="col-md-9 mt-5 mb-5">
                        {
                            this.props.match.isExact ?
                                <div className="col-10 offset-1">
                                    <CourseHomePageBreadcrumb courseName={this.state.courseInfo.name}/>
                                    <br/>
                                    <Card>
                                        <h3 style={{"text-align": 'center'}}> {this.state.courseInfo.name} </h3>
                                        <br/>
                                        <MarkdownRender source={this.state.courseInfo.shortDescription} />
                                    </Card>
                                    {submissionsHtml}
                                </div>
                                :
                                <div></div>

                        }
                        <Route exact path='/s/courses/:courseId/allProblems' component={AllProblemsPage} />
                        <Route exact path='/s/courses/:courseId/topic/:topicId' component={CourseProblemList} />
                        <Route path='/s/courses/:courseId/topic/:topicId/problem/:problemId' 
                                render={(props)=>
                            <ProblemDetails removeNotification = {this.props.removeNotification} {...props}/>}/>
                    </div>
                </div>

            </React.Fragment> : <div></div>
        );
    }
}

export default S_CourseHomePage;
